import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button } from 'antd'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import { Link, withRouter } from 'react-router-dom'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import PropTypes from 'prop-types'

const columns = [
  {
    Header: 'Tracking Number',
    accessor: 'trackingNumber',
    width: 200,
    Cell: ({ value, original }) => (
      <Link to={{ pathname: `/tracking/${original._key}/update` }}>{value}</Link>
    ),
  },
  { Header: 'Tracking Type', accessor: 'type', Cell: ({ value }) => value.toUpperCase() },
  { Header: 'Create Date', accessor: 'date', Cell: DateCell },
  { Header: 'Sales Code', accessor: 'sales.code' },
  { Header: 'Sales Title', accessor: 'sales.title' },
  { Header: 'Company', accessor: 'company.fn' },
  { Header: 'Rep', accessor: 'companyRep.fn' },
  { Header: 'AWB/BOL', accessor: 'ref' },
  { Header: 'Percent', accessor: 'percent' },
  { Header: 'Status', accessor: 'status', width: 200, Cell: StatusCell },
]

function TrackingList (props) {
  const { list, fetch, fetching, company, onChangeCompany, hideCompany } = props
  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() =>
        hideCompany !== true && (
          <OrganisationsSelect
            value={company}
            onChange={onChangeCompany}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{ width: '450px', paddingRight: 20, float: 'right' }}
          />
        )
      }
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={() => {
            props.history.push({ pathname: `/tracking/new` })
          }}>
          New
        </Button>
      )}
      columns={columns}
    />
  )
}

TrackingList.propTypes = {
  list: PropTypes.any,
  fetch: PropTypes.any,
  fetching: PropTypes.any,
  company: PropTypes.any,
  onChangeCompany: PropTypes.any,
  hideCompany: PropTypes.bool,
}
TrackingList.defaultProps = {}

export default withRouter(TrackingList)
